import { type FC, lazy, Suspense } from "react"

import type { LandingPageFaqBlock } from "@forento/core/models/landing"

const RichTextPreview = lazy(() => import("@forento/ui/components/RichTextPreview"))

const FaqBlockPreview: FC<{ block: LandingPageFaqBlock }> = ({ block }) => {
	if (block.content.items.length === 0) return null

	return (
		<section className="px-6 pt-16 pb-0 sm:pt-20 lg:px-8">
			<div className="mx-auto max-w-3xl">
				{block.content.title && (
					<h2 className="text-landing-foreground mb-10 text-center text-3xl font-bold tracking-tight sm:text-4xl">
						{block.content.title}
					</h2>
				)}
				<div className="divide-landing-border border-landing-border bg-landing-surface divide-y rounded-2xl border">
					{block.content.items.map((item, index) => (
						<div key={index} className="p-4 sm:p-5">
							<div className="text-landing-foreground flex items-center justify-between gap-3 text-base font-semibold">
								<span>{item.question || "Question"}</span>
								<span className="bg-landing-surface-muted text-landing-foreground-subtle flex size-7 shrink-0 items-center justify-center rounded-full text-sm">
									+
								</span>
							</div>
							{item.answer && (
								<Suspense>
									<RichTextPreview
										value={item.answer}
										className="text-landing-foreground-muted [&>a]:text-landing-foreground [&>strong]:text-landing-foreground mt-3 text-sm leading-6 [&>a]:font-medium [&>a]:underline [&>a]:underline-offset-4 [&>p]:mb-2 [&>p:last-child]:mb-0 [&>strong]:font-semibold"
									/>
								</Suspense>
							)}
						</div>
					))}
				</div>
			</div>
		</section>
	)
}

export default FaqBlockPreview
